import { Component, Injector, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { GenericBasicGUI } from "src/model/class/component classes/generic-basic-gui";
import { CardKind } from "src/components/shared-components/enum/enumCard";

@Component({
    selector: "app-virtual-access",
    templateUrl: "./virtual-access.component.html",
    styleUrls: ["./virtual-access.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VirtualAccessComponent
  extends GenericBasicGUI
  implements OnInit, OnDestroy {
  public enumCardKind = CardKind;
  public virutalAccessKind: CardKind = CardKind.REAL_CARD; //it's used to rappresent specific card kind reader

  constructor(injector: Injector) {
    super(injector);
  }

  async ngOnInit() {
    this.calculateVirtualAccessComponentType();
  }

  async ngOnDestroy() { }

  /**
   * fill virtual access kind by component "Kind" properties
   */
  private calculateVirtualAccessComponentType(): void {
    this.virutalAccessKind = parseInt(this.ComponentAPI.properties["Kind"]);
  }
}
